import { render, staticRenderFns } from "./a-logo.vue?vue&type=template&id=8a5a76a4&scoped=true"
import script from "./a-logo.vue?vue&type=script&lang=js"
export * from "./a-logo.vue?vue&type=script&lang=js"
import style0 from "./a-logo.vue?vue&type=style&index=0&id=8a5a76a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5a76a4",
  null
  
)

export default component.exports